/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/removeRepo/RemoveRepoPanel.Props" />
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";

export interface IRemoveRepoPanelProps extends IBasePanelContentProps {
    /**
     * Current connection
     */
    connection: ExternalConnection;

    /**
     * Type of repository.
     */
    repositoryType: string;

    /**
     * Callback to save the connection
     */
    onSave: (connection: ExternalConnection) => Promise<ExternalConnection>;
}
